import React, { useState } from 'react';
import s from './ChangeTitle.module.css';
import IconEdit from '../../../../shared/ui/icons/IconEdit';

interface ChangeTitleProps {
    initialTitle: string;
    updateText: (text: string) => void;
}

const ChangeTitle: React.FC<ChangeTitleProps> = ({ initialTitle, updateText }) => {
    const [title, setTitle] = useState(initialTitle);
    const [isEditing, setIsEditing] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value);
    };

    const handleBlur = () => {
        setIsEditing(false);
        updateTitle(title); // заглушка
    };

    const updateTitle = (newTitle: string) => {
        if (newTitle !== initialTitle) {
            updateText(newTitle);
        }
    };

    return (
        <div
            className={s.change_title}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {isEditing ? (
                <input
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    onBlur={handleBlur}
                    autoFocus
                    className={s.input}
                />
            ) : (
                <div onClick={() => setIsEditing(true)} className={s.title_wrapper}>
                    <span className={s.title}>{title}</span>
                    {/* {isHovered && <IconEdit />} */}
                </div>
            )}
        </div>
    );
};

export default ChangeTitle;
